import { epgEndpoint } from '@/api/toya/apiConstantsCodespot'
import { MAX_PROGRAMS_PER_CHANNEL_FETCH_AMOUNT } from '@/shared/constants'
import { postWithAuth } from '@/api/httpRequests'
import { getConfigRepository } from '@/shared/getContainer/getConfigRepository'

const ConfigRepository = await getConfigRepository()
const configRepository = ConfigRepository.Instance

export const getPrograms = async (channelsId: string[]) => {
    const config = configRepository.getLocalConfig()

    if (!config) return null

    const defaultProgramsCount = MAX_PROGRAMS_PER_CHANNEL_FETCH_AMOUNT
    const defaultStartEpochSecs = Math.ceil(Date.now() / 1000) // Date.now() / 1000 i zaokrąglić

    const epgChannelsRequestList = channelsId.map((id) => ({
        channelId: id,
        start: defaultStartEpochSecs,
        count: defaultProgramsCount,
    }))
    epgChannelsRequestList.sort(
        (channelA, channelB) =>
            Number(channelA.channelId) - Number(channelB.channelId)
    )
    const stringifiedChannels = JSON.stringify(epgChannelsRequestList)

    const programsResponse = await postWithAuth(
        epgEndpoint,
        true,
        stringifiedChannels
    )

    return programsResponse
}
